'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Analytics = require('../../global/analytics');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var Analytics__default = /*#__PURE__*/_interopDefaultLegacy(Analytics);

class SignupTracker {
  /**
   * The Signup Tracker helps track events related to the signup modal. It's intended
   * to be used in the context of signup and largely is syntactic sugar over the
   * Analytics component. Events tracked using this component will be emitted to
   * Tealium, Monorail and Google Analytics.
   *
   * @class SignupTracker
   * @constructor
   */
  constructor() {
    this.analyticsEvents = {
      success: {
        eventCategory: 'SignUp',
        eventAction: 'success',
        eventLabel: 'three field',
        dimension1: 'Lead'
      },

      /* eslint-disable babel/camelcase */
      error_shop_name: {
        eventCategory: 'SignUp',
        eventAction: 'error',
        eventLabel: 'Bad shop_name'
      },
      error_email: {
        eventCategory: 'SignUp',
        eventAction: 'error',
        eventLabel: 'Bad email'
      },
      error_password: {
        eventCategory: 'SignUp',
        eventAction: 'error',
        eventLabel: 'Bad password'
      },

      /* eslint-enable babel/camelcase */
      mailcheck: {
        eventCategory: 'SignUp',
        eventAction: 'suggestion',
        eventLabel: 'Email suggestion'
      }
    };
  }
  /**
   * Track a success signup with a custom event object, or with the default `success` event.
   * This will send a success event to Facebook, as well as the underlying Analytics implementation.
   *
   * This event has a deadman's switch when ensures that the Promise will resolve within 450ms.
   *
   * @method trackSuccess
   * @param  {object} customEvent
   * @param  {Object} [tealiumContext={}] Any additional data to be sent to Tealium with the event.
   * @return {Promise[]}
   */


  trackSuccess(customEvent, tealiumContext = {}) {
    const event = customEvent || null; // Deadman's switch to ensure function resolves with 450ms (300 for general Analytics, 150 for FB)

    window.setTimeout(() => Promise.resolve(), 450);
    return Promise.all([this._onSuccess(event, tealiumContext, 300), this._onSuccessFacebookPixel(150)]);
  }
  /**
   * Track errors that arise while completing the fields in the Signup Modal.
   *
   * @method trackError
   * @param  {string} field
   * @param  {object} error
   * @param  {string} val
   * @return {void}
   */


  trackError(field, error, val) {
    const data = field === 'shop_name' ? val : '';
    const action = Object.keys(error).toString();
    Analytics__default.track('threefield_error', `${field}_${action}`, data);
  }
  /**
   * Track an arbitrary event, where `event` is a key in `this.analyticsEvents`, with the Analytics implementation.
   * @method trackEvent
   * @param  {string} event
   * @return {void}
   */


  trackEvent(event) {
    if (event in this.analyticsEvents) {
      Analytics__default.track(this.analyticsEvents[event]);
    }
  }
  /**
   * @deprecated Replaced by `trackEvent`
   * @method sendGAEvent
   * @param  {string} status
   * @return {void}
   */


  sendGAEvent(status) {
    return this.trackEvent(status);
  }
  /**
   * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/events#event_fields
   * @method _onSuccess
   * @private
   * @param {object} customEvent A full event object, or defaults to the success event
   * @param  {Object} [tealiumContext={}] Any additional data to be sent to Tealium with the event.
   * @param {integer} [timeout=300] The maximum time in ms that this function will run for before it resolves.
   * @return {Promise}
   */


  _onSuccess(customEvent, tealiumContext = {}, timeout = 300) {
    const event = customEvent || this.analyticsEvents.success;
    window.setTimeout(() => Promise.resolve(), timeout);
    Analytics__default.track(event, '', '', '', false, tealiumContext);
    return Promise.resolve();
  }
  /**
   * @method _onSuccessFacebookPixel
   * @private
   * @param {integer} [timeout=150] The maximum time in ms that this function will run for before it resolves.
   * @return {Promise}
   */


  _onSuccessFacebookPixel(timeout = 150) {
    // Sets up a dummy promise to wait for Facebook requests as their API
    // does not include a callback.
    window.setTimeout(() => Promise.resolve(), timeout);

    if (typeof window.fbq !== 'undefined') {
      window.fbq('trackCustom', 'LeadSubmit');
    }

    return Promise.resolve();
  }

}

var signupTracker = new SignupTracker();

exports.default = signupTracker;
